import type { ReactNode } from "react"

/**
 * The one card on the canvas that someone not signed in meets, with no shell around it, since
 * there is nowhere to go until Beacon knows who they are: signing in (also at `/oauth/sign-in`),
 * accepting an invitation, and allowing an agent. It is 384px wide, or the screen's width less its
 * 16px gutters on a phone, where it pads 24px rather than 32px, and it stands clear of the notch
 * and the home indicator.
 */
export function AuthCard({ children }: { children: ReactNode }) {
  return (
    <main className="grid min-h-svh place-items-center bg-sidebar px-4 pt-safe pb-safe">
      <div className="w-full max-w-sm rounded-xl bg-background p-8 shadow-dialog compact:p-6">
        {children}
      </div>
    </main>
  )
}
